import {makeActionCreator} from '../../redux-toolbelt';

import {DialogError} from './errorDialogDataReducer';

export const addErrorsToDialog = makeActionCreator<'addErrorsToDialog', DialogError>('addErrorsToDialog');
export const clearErrorsDialog = makeActionCreator<'clearErrorsDialog', never>('clearErrorsDialog');
